module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Exszsk/tc-custom/9781549304538.jpg?1729185199839",
      "alt": "This image is the cover for the book KINO Vol. 2: The End of All Lies, KINO"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("KINO Vol. 2: The End of All Lies, KINO\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Last we saw, Alistair Meath had just gained a sense of awareness that his identity as KINO may not be real. As Alistair continues his journey toward awakening in the real world, Gilmour and Coal continue their mission to find him in Aturo’s secret laboratory. Everything is coming to a head as Aturo struggles to keep Alistair subdued, Coal and Gilmour get closer and closer to finding the missing astronaut, and Alistair’s powers grow even more dangerous and ready to explode out into the real world. Don't miss out on KINO Volume 2, the thrilling conclusion of his mind-bending journey!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joe Casey, Chris Cross, Rob Stull, Jessica Kholinne\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Joe Casey is an American comic book writer. He has worked on titles such as Wildcats 3.0, Uncanny X-Men, The Intimates, Adventures of Superman, and G.I. Joe: America's Elite among others. As part of the comics creator group Man of Action Studios, Casey is one of the creators of the animated series Ben 10.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Oni Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0